<template>
  <div class="top_navigation">
    <div class="inner align_center">
      <div class="left_menu">
        <ul>
          <li>
            <a href="">
              <span class="img">
                  <img src="../assets/img/replug_logo.png" width="142px" alt="Replug">
              </span>
            </a>
          </li>
        </ul>
      </div>
      <div class="right_menu">
        <ul>
          <li><a href="https://replug.io">Home</a></li>
          <li><a href="https://replug.io/pricing">Pricing</a></li>
          <li><a href="https://replug.io/contact">Contact</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopNavigation',
  data () {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TopNavigation.vue